export default import.meta.ROLLDOWN_FILE_URL_a32qSTYXCZF05Uz3Qi5h2g